import Api from './api';
export const getPatrimonyGroups = async () => { 
  let data = [];
  await Api.get('/patrimonygroups')
      .then(result => {
          data = result.data
       })
       .catch(err => {
          data = err;
  });
  return data;
};
